<template>
  <ul class="product-usp">
    <li
      v-for="usp in list"
      :key="usp"
      class="product-usp__list"
    >
      {{ usp }}
    </li>
  </ul>
</template>

<script>

/**
 * Vue: Product USP list (product-usp)
 * -----------------------------------------------------------------------------
 * List of unique selling points on PDP
 *
 * @param {Array} list - USP list
 *
 */

export default {
  name: 'ProductUsp',

  components: {

  },

  props: {
    list: {
      type: Array,
      default() {
        return []
      },
    },
  },

  data() {
    return {
    }
  },

}
</script>

<style lang="scss">
@import './product-usp';
</style>
